<template>
    <div>
        <Entry :entry="entrys"></Entry>

        <IndexNews :list="newsList" :logoUrl="news1"></IndexNews>
        <IndexNews :list="bulletList" :logoUrl="news2"></IndexNews>

        <div class="middle-pic" style="margin-top:16px;">
            <img src="@/../static/mobile_middle.png"/>
        </div>
        <div class="index-line"></div>


        <div class="logo-block">
             <div v-for="item in bannerTypes" v-bind:key="item.typeId" v-if="item.typeCode != '0' && item.typeCode != '6' && item.typeCode != '7' && item.typeCode != '8'">
                <Logos :mode="1" :title='item.typeName' :typeCode='item.typeCode'></Logos>
            </div>
        </div>

    </div>
</template>

<script>

import Menu from "../components/MobileMenu"
import Entry from "../components/MobileEntry"
import IndexNews from "../components/MobileIndexNews"
import Logos from "../components/MobileLogos"

export default {
    name:"Content",
    components:{
        Menu, Entry, IndexNews, Logos
    },data(){
        return {
            newsList:[],
            bulletList:[],
            entrys:[],
            news1:'',
            news2:'',
            bannerTypes:[],
        }
    },
    mounted(){
        this.getEntrys();
        this.getNews();
        this.getBullet();
        this.getFooter();
        this.getColumnInfo1();
        this.getColumnInfo2();
        this.getBannerTypes();
    },
    methods:{
         getBannerTypes(){
            const self = this;
            this.$http.get("/bicycle/inter/bannerTypes").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerTypes = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getColumnInfo1(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=CLNEWS").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.news1 = res.data.data.imageUrl;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getColumnInfo2(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=CLBULLET").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.news2 = res.data.data.imageUrl;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getBanners(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=0").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bannerList = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getEntrys(){
            const self = this;
            this.$http.get("/bicycle/inter/banners?type=8").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.entrys = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        },
        getNews(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo=1&pageSize=4&columnId=CLNEWS&isTop=true").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.newsList = res.data.data.content;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        getBullet(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo=1&pageSize=4&columnId=CLBULLET&isTop=true").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.bulletList = res.data.data.content;
                }
            }).catch(function(error){
                console.log(error);
            });
        },
        
        getFooter(){
            const self = this;
            this.$http.get("/bicycle/inter/footer").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.foot = res.data.data;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>
.m-main-box{
    width: 100%;
    background: white;
    overflow: auto;
    height: 100%;
}
.head-banner{
    margin-top: 5px;
}
.index-line{
    width: 100%;
    height: 6px;
}
.middle-pic{
    height: 70px;
}
.middle-pic img{
    height: 70px;width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileContent.vue